import { render, staticRenderFns } from "./DialogTreeSelect.vue?vue&type=template&id=6d873a4c"
import script from "./DialogTreeSelect.vue?vue&type=script&lang=js"
export * from "./DialogTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports